import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import CollectionOverride from "components/CollectionOverride";

import React from "react";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Button} from "reactstrap";
import {confirmAlert} from "react-confirm-alert";

import {PrintBarcodeModal} from '../../containers/Print';
import ProductLong from "components/Labels/ProductLong";
import UpcShort from "components/Labels/UpcShort";

import {Card, CardContent} from "@material-ui/core";


export default class UPCS extends CollectionOverride {
	constructor(props) {

		let model = new API.BuildClass(Types.Upc_Center._name, API.RequestType.READ_ALL);
		super(props, model);
	}


	printLabel = (e) => {
		const {data} = this.state;
		let pkey = e.original.pkey;
		let binary_id = e.original.binary_id;
		let product;
		let longBarCode, shortBarCode;
		switch (pkey) {
			default: {
				pkey = parseInt(pkey);
				product = data.find((item) => item.pkey === pkey && item.binary_id === binary_id);
				// longBarCode = <ProductLong product={product}/>
				shortBarCode = <UpcShort product={product}/>
			}
		}

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintBarcodeModal
						showFullLabel={false}
						onClose={onClose}
						longBarCode={longBarCode}
						shortBarCode={shortBarCode}
					/>
				);
			}
		});
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [

			{
				Header: "ID",
				id: "pkey",
				accessor: obj => (obj._id ? obj._id : (obj.binary_id + '-' + obj.pkey))
			},
			{
				Header: "SKU",
				id: "sku",
				accessor: obj => obj.sku
			},
			{
				Header: "UPC",
				id: "upc",
				accessor: obj => obj.upc
			},
			{
				Header: "Product Class",
				id: "product_class",
				accessor: obj => obj.product_class
			},
			{
				Header: "Type",
				id: "type",
				accessor: obj => obj.type
			},
			{
				Header: "Model",
				id: "model",
				accessor: obj => obj.model
			},
			{
				Header: "Caliber",
				id: "caliber",
				accessor: obj => obj.calibers ? obj.calibers.name : obj.caliber_other
			},
			{
				Header: "Description",
				id: "item_description",
				accessor: obj => obj.item_description,
				width: 250,

			},
			{
				Header: "Manufacturer",
				id: "manufacturer",
				accessor: obj => obj.manufacturers ? obj.manufacturers.name : obj.manufacturer_other
			},
			// {
			// 	Header: "",
			// 	className: "button-cell",
			// 	filterable: false,
			// 	sortable: false,
			// 	width: 40,
			// 	Cell: props => {
			// 		return (
			// 			<span>
			// 				<Button
			// 					id={props.original.id}
			// 					data-binary-id={props.original.binary_id}
			// 					color="blue-hoki"
			// 					size={"sm"}
			// 					block={true}
			// 					onClick={() => {
			// 						this.printLabel(props);
			// 					}}
			// 				>
			// 					<i className={"fa fa-print"}/>
			// 				</Button>
			// 			</span>
			// 		);
			// 	}
			// },
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,

				Cell: props => {
						return (
							<span>
								<Link to={`/products/upc_center/${props.original.binary_id}-${props.original.pkey}`}>
									<Button color="green-meadow" size={"sm"} block={true}>
										<i className={"fa fa-pencil"}/></Button>
								</Link>
							</span>
						);
					}
			},

			//Todo: determine if we need to show history for the product that the UPC is related to

			// {
			// 	Header: "",
			// 	className: "button-cell",
			// 	filterable: false,
			// 	sortable: false,
			// 	width: 40,
			// 	Cell: props => {
			// 		return (
			// 			<span>
			// 				<Link to={`/products/${props.original._id}#history`}>
			// 					<Button color="default" size={"sm"} block={true}>
			// 						<i className={"fa fa-file-text-o"}/></Button>
			// 				</Link>
			// 			</span>
			// 		);
			// 	}
			// },

			// {
			// 	Header: "Location",
			// 	id: 'location',
			// 	/** @param {Products_Object} obj */
			// 	accessor: obj => (obj.location ? obj.locations.name_display || obj.locations.name : "")
			// },
			// {
			// 	Header: "Acq. Date",
			// 	id: "acquisition_date",
			// 	width: 160,
			// 	/** @param {Products_Object} obj */
			// 	accessor: obj => {
			// 		return obj.acquisition_date ? moment(obj.acquisition_date)
			// 			.local()
			// 			.format("MM/DD/YYYY") : 'Never Acquired'
			// 	}
			// },
			// {

		];
		/** @type {UPCS_Object} object */
		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('UPC')}
								{this.renderHeaderRight("UPC", columns)}
								{/*{this.renderLocationFilter()}*/}
						</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
							renderPageSizeOptions={this.renderPageSizes}
							defaultPageSize={limit}
							pageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>

			</Card>
		)
	}
}
